
export const sFechaPublicacion = '2026-07-28T17:04:01.8705653-06:00';
export const sVersion = 'vAppComedor0.1.607281704';
            